import React, { createContext, useContext, useState, useCallback } from 'react';
import { orgService } from '../api/services';

const UserContext = createContext(null);

const readCurrency = () => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return 'XOF';
    const parsed = JSON.parse(raw);
    return parsed?.orgCurrency || parsed?.organization?.currency || 'XOF';
  } catch {
    return 'XOF';
  }
};

export function UserProvider({ children }) {
  const [orgCurrency, setOrgCurrency] = useState(readCurrency);

  const updateCurrency = useCallback(async (currency) => {
    setOrgCurrency(currency);
    try {
      const raw = localStorage.getItem('user');
      const current = raw ? JSON.parse(raw) : {};
      localStorage.setItem('user', JSON.stringify({ ...current, orgCurrency: currency }));
    } catch {}
    try {
      await orgService.updateSettings({ currency });
    } catch {}
  }, []);

  return (
    <UserContext.Provider value={{ orgCurrency, updateCurrency }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used inside <UserProvider>');
  return ctx;
};
